import type { MediaAsset } from '../../shared/api'
import { api } from '../../shared/api'

/** Displayable URL: public assets have a stable URL; private ones get a short-lived signed URL. */
export async function assetUrl(asset: MediaAsset): Promise<string | null> {
  if (asset.url) return asset.url
  if (asset.status === 'DELETED') return null
  const signed = await api<{ url: string }>(
    `/media/assets/${asset.id}/signed-url`,
  )

  return signed.url
}
